module.exports = __webpack_public_path__ + "static/media/hen_with_mayur.4c7b9da3.gif";